"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSourceInProgram = exports.getVisualMediaSourcesInProgram = exports.getSourceFromProgramLayers = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _checkSourceTypes = require("./checkSourceTypes");
var _utils = require("./utils");
var isSourceInProgram = exports.isSourceInProgram = function isSourceInProgram() {
  var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sourceId = arguments.length > 1 ? arguments[1] : undefined;
  // Check if source exists in program layer
  var _layers$filter$filter = layers.filter(function (layer) {
      return (0, _utils.isItemValid)(layer);
    }).filter(function (layer) {
      var _layer$source;
      return (layer === null || layer === void 0 || (_layer$source = layer.source) === null || _layer$source === void 0 ? void 0 : _layer$source._id) === sourceId;
    }),
    _layers$filter$filter2 = (0, _slicedToArray2["default"])(_layers$filter$filter, 1),
    layerSource = _layers$filter$filter2[0];
  return !!layerSource;
};
var getSourceFromProgramLayers = exports.getSourceFromProgramLayers = function getSourceFromProgramLayers(layers, predicate) {
  return layers === null || layers === void 0 ? void 0 : layers.map(function (layer) {
    return layer === null || layer === void 0 ? void 0 : layer.source;
  }).filter(predicate);
};
var getVisualMediaSourcesInProgram = exports.getVisualMediaSourcesInProgram = function getVisualMediaSourcesInProgram(sourceIdsInProgram, broadcastSources) {
  return broadcastSources.filter(function (source) {
    return sourceIdsInProgram.includes(source._id) && (0, _checkSourceTypes.isVisualMediaSource)(source);
  });
};